<template>
    <footer class="site-footer">
        <div class="site-footer__inner wrapper wrapper--narrow" :class="{ 'is-centered': !isPrefilled }">
            <div class="site-footer__links">
                <a v-for="(item, index) in menuItems" :key="index" :href="item.link" :target="item.target">{{
                    item.text
                }}</a>
                <!--
                <span v-if="getSplashscreen" class="has-pointer">{{ $t('overlays.cookies.menu-label') }}</span>

                <a v-else class="has-pointer" disabled @click="openCookieSettings">{{
                    $t('overlays.cookies.menu-label')
                }}</a>
                -->
                <a href="https://www.psd-rheinneckarsaar.de/" target="_blank">
                    Zur Website der PSD Bank RheinNeckarSaar eG
                </a>
            </div>
            <div class="pull-right is-flex">
                <div v-if="consultantMode" class="consultant-mode">
                    <app-icon icon="consultant" size-px="10px" />
                    {{ $t('global.consultant-mode') }}
                </div>
                <div v-if="isPrefilled" class="update-date">
                    {{ $t('global.update-date', { date: updateDate }) }}
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
import { mapGetters } from 'vuex';
import AppIcon from '@/components/AppIcon';
import EventBus from '@/eventBus';

export default {
    components: { AppIcon },
    data() {
        return {
            menuItems: this.$t('global.site-menu'),
        };
    },
    methods: {
        openCookieSettings() {
            EventBus.$emit('cookie-settings-modal', true);
        },
    },
    computed: {
        ...mapGetters(['getUpdateDate', 'isPrefilled', 'consultantMode', 'getSplashscreen']),
        updateDate() {
            if (this.getUpdateDate) {
                try {
                    const date = new Date(Date.parse(this.getUpdateDate));
                    const lastDayOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
                    // INFO: date.getMonth starts with 0 => 0: jan; 11: dez;
                    return `
                        ${lastDayOfMonth.getDate()}.${lastDayOfMonth.getMonth() + 1}.${lastDayOfMonth.getFullYear()}
                        `;
                } catch (e) {
                    console.error('Could not parse the given Date!');
                    return 'unbekannt';
                }
            }

            return 'unbekannt';
        },
    },
};
</script>
